interface CountLabelProps {
  label: string
  count: number | undefined
}

/** A tab or filter label with its row count beside it. */
export function CountLabel({ label, count }: CountLabelProps) {
  return (
    <>
      {label}
      {count !== undefined && (
        <span className="text-muted-foreground tabular-nums">{count.toLocaleString()}</span>
      )}
    </>
  )
}
